import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { Box } from '@mui/material';

interface Props {
  image?: ReactNode;
  alert?: ReactNode;
  guideSelect?: ReactNode;
  children?: ReactNode;
}

const GuideContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.palette.background.paper};
  padding: ${(props) => props.theme.spacing(2)};
  border-radius: ${(props) => props.theme.shape.borderRadius}px;
`;

const Guide: FC<Props> = ({ image, alert, guideSelect, children }) => {
  return (
    <GuideContainer>
      <Box
        sx={{
          display: 'flex',
          flex: 1,
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          {image}
          {alert}
          {guideSelect}
        </Box>
        <Box sx={{ display: 'flex' }}>{children}</Box>
      </Box>
    </GuideContainer>
  );
};

export default Guide;
